import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import BASE_URL, { getImageURL } from '../../config';
import './CategoryDetails.css';

const CategoryDetail = () => {
  const { id } = useParams();
  const [category, setCategory] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${BASE_URL}/api/categories/${id}/?format=json`)
      .then(response => {
        setCategory({ id: response.data.id, name: response.data.name, slug: response.data.slug });
        setProducts(response.data.products || []);
        setLoading(false);
      })
      .catch(error => {
        setError(error);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <div className="catdetail-loading">
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  if (error) return <p className="catdetail-error">Fehler: {error.message}</p>;

  return (
    <div className="catdetail-page">
      <nav className="catdetail-breadcrumb">
        <Link to="/categories">Kategorien</Link>
        <span className="catdetail-breadcrumb-sep">/</span>
        <span>{category?.name}</span>
      </nav>

      <h1 className="catdetail-title">{category?.name}</h1>
      <p className="catdetail-count">{products.length} Produkt{products.length !== 1 ? 'e' : ''}</p>

      {products.length === 0 ? (
        <p className="catdetail-empty">Noch keine Produkte in dieser Kategorie.</p>
      ) : (
        <div className="catdetail-grid">
          {products.map(product => (
            <Link to={`/product/${product.slug}`} key={product.id} className="catdetail-card">
              <div className="catdetail-card-img-wrap">
                <img
                  src={product.mainimage ? getImageURL(product.mainimage) : (product.images?.[0]?.image ? getImageURL(product.images[0].image) : '')}
                  alt={product.title}
                  className="catdetail-card-img"
                />
                {product.label && product.label !== 'None' && (
                  <span className={`catdetail-badge catdetail-badge-${product.label.toLowerCase()}`}>
                    {product.label}
                  </span>
                )}
              </div>
              <div className="catdetail-card-body">
                <h3 className="catdetail-card-title">{product.title}</h3>
                {product.shortdescription && (
                  <p className="catdetail-card-desc">{product.shortdescription}</p>
                )}
                <div className="catdetail-card-price">
                  {product.discount_price ? (
                    <>
                      <span className="catdetail-price-sale">CHF {product.discount_price}</span>
                      <span className="catdetail-price-orig">CHF {product.price}</span>
                    </>
                  ) : (
                    <span className="catdetail-price">CHF {product.price}</span>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryDetail;
